module.exports = __webpack_public_path__ + "img/waistband partly elastic length.c38ec0c4.png";